import { dehumanizeStatus } from 'src/app/project/modules/points/statuses';
import { TColumn } from '../columns/column.model';
import { statusOrder } from '../columns/property-sorting';
import { ESortOrder } from '../sort-order-enum';
import { TGroupedPoints } from './group-model';

export function groupByStatus(_column: TColumn, _a: TGroupedPoints, _b: TGroupedPoints): number {
  if (statusOrder[dehumanizeStatus(_a.value)] < statusOrder[dehumanizeStatus(_b.value)]) {
    return _column.groupOrder === ESortOrder.ASC ? -1 : 1;
  } else if (statusOrder[dehumanizeStatus(_a.value)] > statusOrder[dehumanizeStatus(_b.value)]) {
    return _column.groupOrder === ESortOrder.ASC ? 1 : -1;
  }
}
